import { Stack, styled, Button } from "@mui/material";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import pageNotFoundAnimation from "../../assests/LottieFiles/page_not_found.json";
import { useNavigate } from "react-router-dom";
import React from "react";

const PageNotFoundWrapper = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(2),
  height: "90vh",
  textAlign: "center",
  padding: theme.spacing(2),
}));

const PageNotFoundContainer = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "90%",
  maxHeight: "70vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/login");
  };

  return (
    <PageNotFoundWrapper>
      <PageNotFoundContainer>
        <DotLottieReact
          data={pageNotFoundAnimation}
          loop
          autoplay
          style={{ width: "100%", maxHeight: "70vh" }}
        />

        <Button
          variant="contained"
          onClick={handleGoHome}
          sx={{
            mt: 2,
            fontSize: "2rem",
            textTransform: "none",
          }}
        >
          Go to Home
        </Button>
      </PageNotFoundContainer>
    </PageNotFoundWrapper>
  );
};

export default PageNotFound;
